export enum VisitStatusEnum {
  InProgress = 1,
  Ended = 2,
  InReview = 3,
  SentToBilling = 4,
  Billed = 5
}

export const VisitStatusOptions = [
{ id: 1, label: 'In Progress' },
{ id: 2, label: 'Ended' },
{ id: 3, label: 'In Review' },
{ id: 4, label: 'Sent To Billing' },
{ id: 5, label: 'Billed' }
];
